import * as yup from 'yup';
import { VALIDATION_MESSAGE } from '../constants/Constants';
import { LanguageConstants } from '../constants/LanguageConstants';
const emojiFreeRegex = /^[\w\s\.,'!&@()-]+$/;



const addressValidation: any = yup.object().shape({
    street_line: yup.string().required(LanguageConstants?.STREET_LINE)
        .min(3, LanguageConstants?.STREET_LINE_DES_MIN)
        .max(250, LanguageConstants?.STREET_LINE_CONTACT_DES_MAX)
        .matches(/^(?!.*\s{2,}).*$/, LanguageConstants?.STREET_LINE_OTHER),
        // .matches(emojiFreeRegex, ("Emojis not allowed")),
    
        appartment: yup.string().optional().notRequired(),
        instructions: yup.string().optional().max(250, "Instructions must be at most 250 characters long"),
        state: yup.string().optional(),
        city: yup.string().optional(),
        zip_code: yup.string().optional(),
        loaction_type: yup.string().required(LanguageConstants?.REQUIRED_LOACTION)

});

export default addressValidation;

